module.exports = __webpack_public_path__ + "img/A-1817249-1579502504-2529.jpeg.efa7656c.jpg";